// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__-cbpH","fadein":"Spinner_fadein__qgvI9","spin":"Spinner_spin__DzLoV"};